import { createContext } from 'react';

const FlyoverContext = createContext();

FlyoverContext.displayName = 'FlyoverContext';

export default FlyoverContext;
